import * as smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

let GLOBAL_SETUP_FLAG = false;

/**
 * Global setup logic that runs once on app startup
 */
if (!GLOBAL_SETUP_FLAG) {
  /**
   * Clear URL state to prevent re-triggering setup logic on page reloads.
   * e.g., in case of initial temporary analysis dashboards.
   * This will clear any state passed via navigation API to avoid re-creation.
   */
  window.history.replaceState(null, '', window.location.href);

  GLOBAL_SETUP_FLAG = true;
}
